import { TENANTS_NAMES, HOST } from './host_config';
import { getTenantPreLoginConfig } from './teanantPreLoginConfig';

// should be a feature flag
const TenantsExtras = {
  [TENANTS_NAMES.intraser]: {
    activeExtras: [
      'MODIFIED_PRICE_EXTRA',
      'INCREMENT_FOR_USING_WEIGHING_SCALE',
      'INCREMENT_FOR_WEIGHT_OVERLOAD',
      'STANDSTILL',
    ],
  },
  [TENANTS_NAMES.acme]: {
    activeExtras: [
      'MODIFIED_PRICE_EXTRA',
      'INCREMENT_FOR_USING_WEIGHING_SCALE',
      'INCREMENT_FOR_WEIGHT_OVERLOAD',
      'STANDSTILL',
    ],
  },
};
const TenantExtras = TenantsExtras[HOST];
// -------------------------------------------------------

const createOrderRedirectConfig = (id) => `${getTenantPreLoginConfig().create_order_redirect}${id}`;

const defaultShipperModuleConfig = {
  list: {
    hidden_columns: [],
    show_include_hidden_filter: false,
  },
  creation: {
    hidden_fields: [],
  },
  detail: {
    showNewDetail: false,
  },
};

const shipperModuleConfigPerTenant = {
  [TENANTS_NAMES.ontruck]: {
    list: {
      hidden_columns: ['externalId', 'email', 'workingAreas'],
      show_include_hidden_filter: true,
    },
  },
  [TENANTS_NAMES.intraser]: {
    list: {
      hidden_columns: ['externalId', 'email', 'workingAreas'],
      show_include_hidden_filter: true,
    },
    creation: {
      hidden_fields: ['external_id', 'workingAreas'],
    },
  },
  [TENANTS_NAMES.xpo]: {
    creation: {
      hidden_fields: ['tax_number'],
    },
    detail: {
      showNewDetail: true,
    },
  },
  [TENANTS_NAMES.ontime]: {
    list: {
      hidden_columns: ['externalId', 'email', 'workingAreas'],
      show_include_hidden_filter: false,
    },
    creation: {
      hidden_fields: ['external_id', 'workingAreas'],
    },
    detail: {
      showNewDetail: true,
    },
  },
};

const GIS_HEADERS = {
  'X-Auth-Tenant-Name': getTenantPreLoginConfig().gis_headers,
};

const getShipperModuleConfig = (tenant_name) => {
  const shipperModuleConfig = { ...defaultShipperModuleConfig };
  if (tenant_name in shipperModuleConfigPerTenant) {
    Object.assign(shipperModuleConfig, shipperModuleConfigPerTenant[tenant_name]);
  }
  return shipperModuleConfig;
};

export { TenantExtras, GIS_HEADERS, createOrderRedirectConfig, getShipperModuleConfig };
